import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { cancelFunctions } from 'utils/cancelFunctions';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { getLocaleCode, getMarketId } from 'store/publisher/selectors';
import {
  filterByAssetOwner,
  hiddenAssetOwnerThoughtspotLiveboardStyles,
  labsReportVisibleActions,
  TABS_STYLES,
} from '../LabsReportDropdown/utils';

const ProofOfPlayChina: React.FC = () => {
  const localeCode = useSelector(getLocaleCode);
  const marketId = useSelector(getMarketId);

  initialiseThoughtspot(localeCode, cancelFunctions);

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={thoughtspot.chinaProofOfPlayLiveboardId}
        filterByOptions={[filterByAssetOwner(marketId)]}
        customizations={hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
      />
    </div>
  );
};

export default ProofOfPlayChina;
